import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import PropTypes from 'prop-types';

import {resetProgress} from '~/actions/UploadActions';

import {getError, isSuccessful, isUploading} from '~/selectors/UploadSelectors';
import {selectedIcon as getSelectedIcon} from '~/selectors/CanvasSelectors';

import withRouter, {routerPropTypes} from '~/router/withRouter';

import ContentCard from '~/components/ContentCard';
import HelpfulTip from '~/components/HelpfulTip';
import Spinner from '~/components/Spinner';

import './index.scss';
import {Box} from '@customink/pigment-react';
import MedalliaSuvery from '~/components/AddTextCard_Lg/MedalliaSurvey';

/** @param {PropTypes.InferProps<typeof propTypes>} props - Component properties. */
export function ProgressIndicator({router, isLarge}) {
  const dispatch = useDispatch();

  const error = useSelector(getError);
  const uploading = useSelector(isUploading);
  const successful = useSelector(isSuccessful);
  const selectedIcon = useSelector(getSelectedIcon);

  useEffect(() => {
    return () => dispatch(resetProgress());
  }, []);

  useEffect(() => {
    if (error) {
      router.navigate(isLarge ? '/uploadForm' : '/');
    }
  }, [error, isLarge, router]);

  useEffect(() => {
    if (!uploading && selectedIcon?.rendered) {
      router.navigate('/uploadTools');
    }
  }, [router, selectedIcon?.rendered, uploading]);

  return (
    <ContentCard
      contentClassName="ndx-ProgressIndicator"
      title="Uploading"
      onNavClose={() => router.navigate('/')}>
      <div className="ndx-ProgressIndicator-spinner">
        <Spinner success={!!successful} />
      </div>
      <HelpfulTip>
        Every order includes FREE shipping and FREE design review.
      </HelpfulTip>
      <Box sx={{margin: 2}}>
        <MedalliaSuvery type={'upload'} />
      </Box>
    </ContentCard>
  );
}

const propTypes = {
  router: routerPropTypes.isRequired,
  isLarge: PropTypes.bool
};

ProgressIndicator.propTypes = propTypes;

export default withRouter(ProgressIndicator);
